import React, { useState, useEffect } from 'react';
import { Window } from "@progress/kendo-react-dialogs";
import api from '../FetchComponents/FetchComponentsServices';
import { Loader } from "@progress/kendo-react-indicators";
import { Grid, GridColumn } from '@progress/kendo-react-grid';

const MoreUpdatesWindow = ({osuIdmID, closeWindow}) => {
    const [windowStage, setWindowStage] = useState("DEFAULT");
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState([]);
    const [error, setError] = useState('');
    const [name, setName] = useState(osuIdmID);

    const handleStageChange = (e) => {
        setWindowStage(e.state);
        if(e.state === "MINIMIZED") {
            closeWindow()
        }
    };

    useEffect(async () => {
        if(osuIdmID && osuIdmID.length > 0) {
            var details = await api.GetUserHistory(osuIdmID).then(data => {
                return data
            }).catch(error => {
              console.log(error) // todo add better logging / error handing
            })
            if(!details) {
                setError('Unable to retrieve more details')
            }
            if(details && !details.length) {
                setError('No Details Found')
            }
            if(details && details.length > 0) {
                let recordWithName = details.find(person => person.firstName !== null && person.lastName !== null);
                let name = `${recordWithName.firstName?.trim()} ${recordWithName.lastName?.trim()}`
                if(recordWithName && recordWithName.preferredFirstName && recordWithName.preferredFirstName.trim() !== "") {
                    name = `${recordWithName.preferredFirstName} (${recordWithName.firstName}) ${recordWithName.lastName}`
                }
                setName(name)
                setDetails(details.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)))
            }
        }
        setLoading(false)
    }, [])

    return (
        <Window title={`More Details for User: ${name}: Records: ${details.length ?? 0}`} 
            initialHeight={500} 
            initialWidth={800} 
            initialTop={window.scrollY + 50}
            stage={windowStage} 
            onStageChange={handleStageChange} 
            onClose={closeWindow}>
            {loading && <span><Loader className='spinner-small' size="small" type={"infinite-spinner"} /> Loading Job Details</span>}
            {error.length 
                ? <p className='warning'>{error}</p>
                :  <div>
                    {
                        !loading && <Grid data={details}>
                            <GridColumn width={150} field="actionDone" title="Action"/>
                            <GridColumn field="notes" title="Notes" />
                            <GridColumn width={230} field="createdDate" title="Created Date" format={"{0:G}"} />
                        </Grid>
                    }
                </div>
            }
        </Window>
    );
};

export default MoreUpdatesWindow